import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import { Routes, Route } from "react-router-dom";
import { CustomNavbar } from './components/CustomNavbar';
import Home from './components/Home';
import ReferencesPage from './components/Reference';
import Video from './components/Video';
import Footer from './components/Footer';
import React from 'react';
import VRPage from './components/VRPage';
import Dialog from './components/Dialog';

function App() {
  /*Initialize AOS (Animate On Scroll)*/
  React.useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with animation duration
  }, []);

  return (
    <>
        <div className="App">
          <CustomNavbar/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vr" element={<VRPage />} />
            <Route path="/dialog" element={<Dialog />} />
            <Route path="/about" element={<ReferencesPage />} />
            <Route path="/video" element={<Video />} />
          </Routes>
          <Footer/>
        </div>
    </>
  );
}

export default App;
